import {OktaAuthOptions} from '@okta/okta-auth-js'

let config: typeof OktaAuthOptions
if (__WEBPACK_ISPROD__) {
  config = {
    clientId: globalThis.import_meta_env.OKTA_CLIENT_ID,
    issuer: globalThis.import_meta_env.OKTA_URL,
    redirectUri: `${window.location.origin}/login/callback`,
    scopes: ['openid', 'profile', 'email', 'groups'],
  }
} else {
  config = {
    clientId: OKTA_CLIENT_ID,
    issuer: `${OKTA_URL}/oauth2/default`,
    redirectUri: `${window.location.origin}/login/callback`,
    scopes: ['openid', 'profile', 'email', 'groups'],
  }
}

export default config
